import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthData } from '../context/auth';
import LargeCenterSpinner from './LargeCenterSpinner';

interface LogoutProps {
	authData: AuthData;
}

const Logout = ({ authData }: LogoutProps) => {
	const location = useLocation();
	const navigate = useNavigate();
	React.useEffect(() => {
		const logout = async () => {
			if (authData.auth) {
				await authData.clear();
			}
			navigate('/' + location.search);
		};
		logout();
	}, [authData, navigate, location.search]);

	return <LargeCenterSpinner />;
};

export default Logout;
